import { FaSun, FaMoon } from 'react-icons/fa'
import AppProvider from '../context/AppProvider'
import './ThemeSwitcher.css'
import PropTypes from 'prop-types'

const ThemeSwitcher = ({ className }) => {
	const { theme, toggleTheme } = AppProvider.useContext()

	const getIcon = () => {
		if (theme === 'dark') return <FaMoon size={27} className='text-white' />
		return <FaSun size={27} className='text-warning' />
	}

	const getLabel = () => {
		if (theme === 'dark') return 'Dark Theme'
		return 'Light Theme'
	}

	return (
		<div className={`${className ? className : 'theme-switcher'} d-print-none`}>
			<button
				type="button"
				className="btn btn-link d-flex align-items-center gap-2"
				onClick={toggleTheme}
				title={getLabel()}
			>
				{getIcon()}
				<span className='d-none'>{getLabel()}</span>
			</button>
		</div>
	)
}

ThemeSwitcher.propTypes = {
	// This component does not take props directly, but for custom use cases, you could add them here.
	className: PropTypes.string,
}

export default ThemeSwitcher
